import {domainUrl} from "../../../../helper";
import Image from "next/image";
import React, {FC, Fragment} from "react";

interface ISmartSearchStepOne {
    listItem: Array<any>
    step2Id: number | undefined,
    setStep2Id: (x: number) => void,
    dbName: string
    domain: string
}

const SmartSearchStepOne: FC<ISmartSearchStepOne> = (
    {
        listItem,
        dbName,
        domain,
        setStep2Id
    }
) => {
    const handleChooseCat = ((item: any) => {
        setStep2Id(item)
    })

    const stepOneItems = listItem.map((item, index) => {
        return <Fragment key={index}>
            <div className="smart-saerch-item-wrapper" onClick={() => handleChooseCat(item)}>
                <div className="step-one-img-wrapper">
                    <Image
                        src={domainUrl(`${dbName}/storage/${domain}/${item.image}`)}
                        alt={item.name}
                        placeholder="blur"
                        layout="fill"
                        priority
                        blurDataURL={`/zega/blur1.webp`}
                        objectFit="contain"
                    />
                </div>

                <div className="step-one-description">
                <span>
                    {item.name}
                </span>
                </div>
            </div>
        </Fragment>
    })

    return <>
        <div className="step-one-wrapper">
            <div className="smart-search-step-one">
                {stepOneItems}
            </div>
        </div>
    </>
};

export default SmartSearchStepOne